import type { IContainer } from '../interface/container';
import utils from '../private';

export function injectContainer(name = 'default'): IContainer | undefined {
    const containers = utils.globalStorage.getContainerMap();

    const container = containers[name];

    return container;
}

export function bindContainer(container: IContainer, name = 'default'): void {
    const containers = utils.globalStorage.getContainerMap();

    if (containers[name] !== undefined) {
        utils.log.warn(`Overwriting container: ${name}`);
    }

    containers[name] = container;
}

export function removeContainer(name = 'default'): void {
    const containers = utils.globalStorage.getContainerMap();

    if (containers[name] !== undefined) {
        delete containers[name];
    }
}
